<template>
    <b-modal ref="mdlConfigurazioneTipoSoggetto" :title="title" centered no-close-on-backdrop no-close-on-esc
        hide-header-close size="lg" @ok="onOkMdlContabilitaTipoSoggetto" @show="onShow">
        <b-row>
            <b-col cols="12" xs="12" sm="2" md="4" lg="4" xl="4">
                <label class="sa-label-data">Codice Struttura</label>
                <b-form-select v-model="jsonData.codiceAzienda" :value="null">
                    <template #first>
                        <b-form-select-option :value="null"> - Tutte -
                        </b-form-select-option>
                    </template>
                    <b-form-select-option v-for="tipoDoc in strutturaOptions" :key="tipoDoc.id"
                        :value="tipoDoc.codiceStruttura"> {{
                            tipoDoc.denominazione }} ({{ tipoDoc.codiceStruttura }}) </b-form-select-option>
                </b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                <label class="sa-label-data">Codice Tipo Soggetto</label>
                <b-form-input v-model="jsonData.codiceTipoSoggetto"></b-form-input>
            </b-col>

            <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                <label class="sa-label-data">Codice Soggetto Collegato</label>
                <b-form-input v-model="jsonData.codiceSoggettoCollegato"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Descrizione Tipo Soggetto</label>
                <b-form-input v-model="jsonData.descrizioneTipo"></b-form-input>
            </b-col>
        </b-row>
        <!-- <template #modal-footer>
			<b-button v-if="!isReadOnly" size="md" variant="outline-danger" @click="onCloseModal">Annulla</b-button>
			<b-button v-if="!isReadOnly" size="md" variant="outline-success" @click="onClickSalvaDocumento">Salva</b-button>
			<b-button v-if="isReadOnly" size="md" variant="outline-secondary" @click="onCloseModal">Chiudi</b-button>
		</template> -->
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>
<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import ContabilitaMixin from "../mixins/ContabilitaMixin";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    mixins: [UtilityMixin, StruttureMixin, ContabilitaMixin],
    components: { ModalError },
    data() {
        return {
            title: null,
            pathResource: "/contabilitasoggettotipi",
            isReadOnly: false,
            jsonData: {
                codiceAzienda: null,
                codiceTipoSoggetto: null,
                descrizioneTipo: null,
                codiceSoggettoCollegato: null
            },
            presidio: {},
        };
    },
    mounted() {
        this.struttureLoadData();
        this.setPresidio();
    },
    methods: {
        show(jsonData) {
            let me = this;
            this.title = "Nuovo Tipo Soggetto";
            if (jsonData?.id) {
                this.title = "Modifica Tipo Soggetto";
                this.jsonData = JSON.parse(JSON.stringify(jsonData));
            } else {
                this.resetJsonDataTipoSoggetto();
            }
            me.$refs.mdlConfigurazioneTipoSoggetto.show();
            this.setStrutturaUtente();
        },
        onCloseModal() {
            let me = this;
            me.jsonData = {};
            me.$emit("onCloseModal");
            me.$refs.mdlConfigurazioneTipoSoggetto.hide();
        },
        setStrutturaUtente() {
            console.log(this.presidio.codiceStruttura);
            let struttura = this.strutturaOptions.filter(e => e.codiceStruttura == this.presidio.codiceStruttura);
            if (struttura[0]) {
                this.jsonData.codiceAzienda = struttura[0].codiceStruttura;
            }

        },
        resetJsonDataTipoSoggetto() {
            this.jsonData = {
                id: null,
            };
        },
        setPresidio() {
            let tmpPresidio = window.localStorage.getItem("presidio");
            if (tmpPresidio) {
                this.presidio = JSON.parse(tmpPresidio);
                this.strutturaLoadDataByCodice(this.presidio.codiceStruttura);
            }
        },

        validazione() {
            let esito = true;
            let msg = "";

            if (this.jsonData.codiceIva == null || this.jsonData.codiceIva.trim() == "") {
                msg += "Codice Iva  non valido ! #";
                esito = false;
            }
            return { esito: esito, msg: msg };
        },
        generaBtoast(validation) {
            let message = validation.msg.split("#");
            const h = this.$createElement;
            const vNodesMsg = h("ul", { style: "margin-left: -18px" }, []);
            message.forEach((element) => {
                if (element.trim() != "") {
                    vNodesMsg.children.push({ tag: "li", text: element });
                }
            });
            this.$bvToast.toast([vNodesMsg], {
                title: "Attenzione!",
                autoHideDelay: 5000,
                variant: "danger",
            });
        },
        contabilitaTipoDocumentoLoadDataSuccess(response) {
            this.tipoDocumentoOptions = response.data.data;
            console.log(this.tipoDocumentoOptions);
        },
        onShow() { },
        onOkMdlContabilitaTipoSoggetto(bvModalEvent) {
            let me = this;
            bvModalEvent.preventDefault();
            let validation = me.validazione();
            if (!validation.esito) {
                me.generaBtoast(validation);
                return;
            }
            this.openShowModalLoading();
            this.$emit("beforeSave");
            this.saveResource(me.pathResource, me.jsonData, me.saveResourceSuccess, me.saveResourceError);
        },
        saveResourceSuccess() {
            this.$refs.mdlConfigurazioneTipoSoggetto.hide();
            this.$emit("afterSave");
            this.closeShowModalLoading();
            this.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        saveResourceError(error) {
            let message = error.response.data.messaggio;
            this.errorToast(message);
        },
    },
};
</script>
